<template>
    <div
        v-if="access && access.level === 'limited'"
        class="rounded-[6.75px] bg-[#161E2E] px-4 py-3"
    >
        <p class="text-sm font-medium text-white">
            {{ t("vue.ai_trial_overview_title") }}
        </p>

        <div class="mt-3 flex items-center justify-between gap-2 text-sm">
            <span class="truncate text-white">{{ t("vue.ai_chat") }}</span>
            <span class="shrink-0 text-gray-300">
                {{ t("vue.ai_chat_messages_left", { count: messagesLeft }) }}
            </span>
        </div>

        <div class="mt-2 h-2 w-full rounded-full bg-[#2A3344]">
            <div
                class="h-2 rounded-full transition-all duration-200"
                :class="barClass"
                :style="{ width: `${access.percent}%` }"
            ></div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useTranslations } from "@/composables/useTranslations";
import { aiUsageBarClass } from "@/utils/aiUsageBar";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const { t } = useTranslations();

// Trial / extended-trial teams only: how much of the AI message cap remains.
const access = computed(() => usePage<IRhizomPageProps>().props.aiChat);

const messagesLeft = computed<number>(() =>
    Math.max(0, (access.value?.limit ?? 0) - (access.value?.used ?? 0)),
);

const barClass = computed<string>(() =>
    aiUsageBarClass(access.value?.percent ?? 0),
);
</script>
